<app-project-item-list
  itemRouteSuffix="/update"
  title="Select Project to update"
  action="Update"
></app-project-item-list>
